"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _focusStylesListener = require("../listeners/focusStylesListener");

var _renderProp = require("../utils/propTypes/renderProp");

var _colors = require("HubStyleTokens/colors");

var _UIButton = _interopRequireDefault(require("../button/UIButton"));

var _Functions = require("../core/Functions");

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _SyntheticEvent = _interopRequireDefault(require("../core/SyntheticEvent"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _Fonts = require("../utils/Fonts");

var _decorators = require("../utils/propTypes/decorators");

var _UIOverhang = _interopRequireDefault(require("../scroll/UIOverhang"));

var _UIIcon = _interopRequireDefault(require("../icon/UIIcon"));

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _Timers = require("../utils/Timers");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ExpandableTextOverhang = (0, _styledComponents.default)(_UIOverhang.default).withConfig({
  displayName: "UIExpandableText__ExpandableTextOverhang",
  componentId: "sc-1y91zlz-0"
})(_templateObject(), function (props) {
  return props.scrollable && "\n    /* Compensate for border on scroll container */\n    right: 1px;\n    bottom: 1px;\n    left: 1px;\n  ";
});
ExpandableTextOverhang.propTypes = (0, _extends2.default)({}, _UIOverhang.default.propTypes, {
  scrollable: _propTypes.default.bool.isRequired
});
ExpandableTextOverhang.defaultProps = _UIOverhang.default.defaultProps;

var getStyle = function getStyle(computedMaxHeight) {
  return {
    maxHeight: computedMaxHeight
  };
}; // If a rems value exists, convert it to px and return it; otherwise, return the px value.


var pxValue = function pxValue(px, rems) {
  return rems != null ? rems * 16 : px;
};

var UIExpandableText = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(UIExpandableText, _React$Component);

  function UIExpandableText(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIExpandableText);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIExpandableText).call(this, props));

    _this.delayedFitToMaxLines = function () {
      (0, _Timers.cancelSchedulerCallback)(_this._timeout);
      _this._timeout = (0, _Timers.requestSchedulerCallback)(_this.fitToMaxLines);
    };

    _this.fitToMaxLines = function () {
      if (!_this._el) return;
      var _this$props = _this.props,
          maxHeight = _this$props.maxHeight,
          maxHeightRems = _this$props.maxHeightRems;
      var _this$state = _this.state,
          collapsible = _this$state.collapsible,
          contentHeight = _this$state.contentHeight;
      var scrollHeight = _this._el.scrollHeight;

      if (contentHeight !== scrollHeight) {
        _this.setState({
          contentHeight: scrollHeight
        });
      }

      var contentOverflows = scrollHeight > pxValue(maxHeight, maxHeightRems);

      if (collapsible !== contentOverflows) {
        _this.setState({
          collapsible: contentOverflows
        });
      }
    };

    _this.handleExpandButtonClick = function (evt) {
      var _this$props2 = _this.props,
          onExpandButtonClick = _this$props2.onExpandButtonClick,
          onExpandedChange = _this$props2.onExpandedChange;
      (0, _Functions.callIfPossible)(onExpandButtonClick, evt);
      onExpandedChange((0, _SyntheticEvent.default)(true));
    };

    _this.handleCollapseButtonClick = function (evt) {
      var _this$props3 = _this.props,
          onCollapseButtonClick = _this$props3.onCollapseButtonClick,
          onExpandedChange = _this$props3.onExpandedChange;
      (0, _Functions.callIfPossible)(onCollapseButtonClick, evt); // Set explicit max-height (removed by handleTransitionEnd) for transition

      var textWrapperEl = _this._el;
      textWrapperEl.style.maxHeight = textWrapperEl.scrollHeight + "px";
      onExpandedChange((0, _SyntheticEvent.default)(false));
    };

    _this.handleTextWrapperFocus = function (evt) {
      var _this$props4 = _this.props,
          expandOnFocus = _this$props4.expandOnFocus,
          onExpandedChange = _this$props4.onExpandedChange,
          toggleable = _this$props4.toggleable;

      if (expandOnFocus && toggleable) {
        // Avoid expanding on focus if the user clicked a link or other extraneous element.
        if (!(0, _focusStylesListener.isPageInKeyboardMode)() && !/TEXTAREA|INPUT/.test(evt.target.tagName)) return;
        onExpandedChange((0, _SyntheticEvent.default)(true));
      }
    };

    _this.handleTextWrapperTransitionEnd = function (evt) {
      // After the expand transition, remove max-height in case the content grows/shrinks
      var textWrapperEl = _this._el;

      if (evt.target === textWrapperEl && evt.propertyName === 'max-height') {
        var _this$state2 = _this.state,
            expanded = _this$state2.expanded,
            fullyExpanded = _this$state2.fullyExpanded;

        if (expanded && !fullyExpanded) {
          _this.setState({
            fullyExpanded: true
          });
        }
      }
    };

    _this.textWrapperRefCallback = function (ref) {
      _this._el = ref;
    };

    _this.state = {
      contentHeight: null,
      // How tall is the content?
      collapsible: false,
      // Does the content exceed our max height?
      fullyExpanded: false // Did the CSS transition from collapsed to expanded complete?

    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UIExpandableText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.delayedFitToMaxLines();
      this.startMutationObserver();
      addEventListener('resize', this.delayedFitToMaxLines);
      if (this._el) this._el.addEventListener('load', this.delayedFitToMaxLines, true); // #5980: need to add this handler manually

      if (!(0, _Fonts.fontsLoaded)()) _Fonts.fontsLoadedPromise.then(this.delayedFitToMaxLines);
    }
  }, {
    key: "UNSAFE_componentWillUpdate",
    value: function UNSAFE_componentWillUpdate() {
      this.stopMutationObserver();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.contentHeight === this.state.contentHeight && prevState.collapsible === this.state.collapsible) {
        this.delayedFitToMaxLines();
      }

      if (prevState.collapsible !== this.state.collapsible) {
        (0, _Functions.callIfPossible)(this.props.onCollapsibleChange, this.state.collapsible);
      }

      this.startMutationObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopMutationObserver();
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
      removeEventListener('resize', this.delayedFitToMaxLines);
      if (this._el) this._el.removeEventListener('load', this.delayedFitToMaxLines, true);
    }
  }, {
    key: "startMutationObserver",
    value: function startMutationObserver() {
      if (!this._el) return; // When the content changes, recalculate our size

      this._observer = new MutationObserver(this.delayedFitToMaxLines);

      this._observer.observe(this._el, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "stopMutationObserver",
    value: function stopMutationObserver() {
      if (this._observer) {
        this._observer.disconnect();

        this._observer = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          buttonAlign = _this$props5.buttonAlign,
          children = _this$props5.children,
          className = _this$props5.className,
          collapseButtonText = _this$props5.collapseButtonText,
          expandButtonText = _this$props5.expandButtonText,
          expanded = _this$props5.expanded,
          fadeOutHeight = _this$props5.fadeOutHeight,
          fadeOutHeightRems = _this$props5.fadeOutHeightRems,
          gradientColor = _this$props5.gradientColor,
          hideButtonCaret = _this$props5.hideButtonCaret,
          maxHeight = _this$props5.maxHeight,
          maxHeightRems = _this$props5.maxHeightRems,
          onCollapseButtonClick = _this$props5.onCollapseButtonClick,
          onExpandButtonClick = _this$props5.onExpandButtonClick,
          Overhang = _this$props5.Overhang,
          scrollable = _this$props5.scrollable,
          toggleable = _this$props5.toggleable,
          use = _this$props5.use;
      var _this$state3 = this.state,
          collapsible = _this$state3.collapsible,
          contentHeight = _this$state3.contentHeight,
          fullyExpanded = _this$state3.fullyExpanded;
      var computedClassName = (0, _classnames.default)(className, 'private-expandable-text', {
        'private-expandable-text--scrollable': scrollable
      });
      var computedButtonClassName = (0, _classnames.default)('private-expandable-text__toggle-button', {
        'align-left': buttonAlign === 'left' && !scrollable,
        'align-right': scrollable
      });
      var computedMaxHeight = expanded ? contentHeight : pxValue(maxHeight, maxHeightRems);
      var showToggleButton = toggleable && collapsible;
      var renderedButton = showToggleButton ? _react.default.createElement(_UIButton.default, {
        "aria-hidden": expanded ? !onCollapseButtonClick : !onExpandButtonClick,
        className: computedButtonClassName,
        onClick: expanded ? this.handleCollapseButtonClick : this.handleExpandButtonClick,
        use: "link"
      }, scrollable || hideButtonCaret ? null : _react.default.createElement(_UIIcon.default, {
        color: _colors.CALYPSO,
        name: expanded ? 'up' : 'down'
      }), (0, _lazyEval.default)(expanded ? collapseButtonText : expandButtonText)) : null;
      var defaultGradientColor = use === 'on-dark' ? _colors.GYPSUM : _colors.OLAF;
      return _react.default.createElement("div", {
        className: "private-expandable-text__container",
        "data-collapsible": collapsible
      }, scrollable && renderedButton, _react.default.createElement("div", {
        className: "private-expandable-text__overhang-wrapper"
      }, _react.default.createElement("div", {
        className: computedClassName,
        onFocus: this.handleTextWrapperFocus,
        onTransitionEnd: this.handleTextWrapperTransitionEnd,
        ref: this.textWrapperRefCallback,
        style: fullyExpanded ? null : this._getStyle(computedMaxHeight)
      }, children), collapsible && !expanded ? _react.default.createElement(Overhang, {
        gradientColor: gradientColor != null ? gradientColor : defaultGradientColor,
        scrollable: scrollable,
        side: "bottom",
        size: pxValue(fadeOutHeight, fadeOutHeightRems)
      }) : null), !scrollable && renderedButton);
    }
  }]);
  return UIExpandableText;
}(_react.default.Component);

UIExpandableText.propTypes = {
  buttonAlign: _propTypes.default.oneOf(['left', 'center']).isRequired,
  children: _propTypes.default.node.isRequired,
  collapseButtonText: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  expandButtonText: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  expanded: _propTypes.default.bool,
  expandOnFocus: _propTypes.default.bool.isRequired,
  fadeOutHeight: _propTypes.default.number.isRequired,
  fadeOutHeightRems: (0, _decorators.hidden)(_propTypes.default.number),
  gradientColor: _propTypes.default.string,
  hideButtonCaret: _propTypes.default.bool.isRequired,
  maxHeight: _propTypes.default.number.isRequired,
  maxHeightRems: (0, _decorators.hidden)(_propTypes.default.number),
  onCollapsibleChange: (0, _decorators.hidden)(_propTypes.default.func),
  onCollapseButtonClick: _propTypes.default.func,
  onExpandButtonClick: _propTypes.default.func,
  onExpandedChange: _propTypes.default.func,
  Overhang: (0, _renderProp.getPropType)(ExpandableTextOverhang),
  scrollable: _propTypes.default.bool,
  toggleable: _propTypes.default.bool,
  use: _propTypes.default.oneOf(['default', 'on-dark'])
};
UIExpandableText.defaultProps = {
  buttonAlign: 'center',
  collapseButtonText: function collapseButtonText() {
    return _I18n.default.text('salesUI.UIExpandableText.collapseButtonText');
  },
  expandButtonText: function expandButtonText() {
    return _I18n.default.text('salesUI.UIExpandableText.expandButtonText');
  },
  expanded: false,
  expandOnFocus: true,
  fadeOutHeight: 32,
  hideButtonCaret: false,
  maxHeight: 80,
  Overhang: ExpandableTextOverhang,
  scrollable: false,
  toggleable: true,
  use: 'default'
};
UIExpandableText.displayName = 'UIExpandableText';

var _default = (0, _Controllable.default)(UIExpandableText, ['expanded']);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/text/UIExpandableText.js
// module id = 404
// module chunks = 209 210 211 212